export const adminSubscriptionID = process.env.REACT_APP_SUBSCRIPTION_ADMIN_ID || 'kinkeeper.premium.admin';